import * as React from 'react';
import { Link } from 'react-router-dom';

import { history } from '../..';

import { Dialog, DialogProperties } from '@common/components';
import { Modal, ModalProps } from '@common/components/modal';
import { config } from '@common/config';
import { getModule, RouteDefinitions } from '@common/route-definitions';
import { ProfileViewModel } from '@models/Auth';

import * as classes from './header.scss';
import { UnregisterCallback } from 'history';

export interface HeaderComponentProperties {
  readonly profile: ProfileViewModel | null;
  readonly isLoggedIn: boolean;
  readonly timerExpired: boolean;
  readonly time: string;
  readonly modalProps?: ModalProps;
  readonly dialogProps?: DialogProperties;
  readonly showModal: boolean;
  readonly showDialog: boolean;
  readonly isSidebarOpen: boolean;
  readonly toggleSidebar: () => void;
  readonly getProfile: () => void;
  readonly onResetClick: () => void;
  readonly stopMocking: () => void;
}

interface HeaderComponentState {
  currentLocation: string;
}

// Component definition
export class HeaderComponent extends React.Component<HeaderComponentProperties, HeaderComponentState> {
  private historyListener: UnregisterCallback | null = null;

  constructor(props: HeaderComponentProperties) {
    super(props);
    this.state = {
      currentLocation: getModule(location.pathname.split('/')[1])
    };
  }

  public componentDidMount() {
    if (!this.props.profile && this.props.isLoggedIn) {
      this.props.getProfile();
    }
  }

  public componentWillUnmount() {
    if (this.historyListener) {
      this.historyListener();
    }
  }

  public render(): JSX.Element {
    return (
      <div className={classes.container}>
        {config.environment !== 'PROD' && (
          <>
            <h5>Timer Expired?: {`${this.props.timerExpired}`}</h5>
            <h5>Time: {this.props.time}</h5>
            <h5>
              Popup at: {config.minutesUntilLogoutPopup}
              :00
            </h5>
            <h5>
              Logout at: {config.minutesUntilAutoLogout}
              :00
            </h5>
          </>
        )}
        {this.renderTips()}
        {this.renderTimerDialog()}
        {this.renderModal()}
        {this.renderDialog()}
        {this.props.isLoggedIn && (
          <div className="col-md-4">
            <i
              onClick={e => this.props.toggleSidebar()}
              className={[classes.toggle, 'fa fa-bars fa-fw fa-2x'].join(' ')}
            />
          </div>
        )}
      </div>
    );
  }

  private listenForChanges = (): void => {
    this.historyListener = history.listen(location => {
      this.setCurrentLocation(location.pathname);
    });
  };

  private renderDialog(): JSX.Element {
    if (!this.props.showDialog) {
      return <></>;
    }

    return React.createElement(Dialog, this.props.dialogProps);
  }

  private renderModal(): JSX.Element {
    if (!this.props.showModal || !this.props.modalProps) {
      return <></>;
    }

    return React.createElement(Modal, this.props.modalProps);
  }

  private renderTimerDialog(): JSX.Element {
    if (!this.props.timerExpired) {
      return <></>;
    }

    return (
      <Dialog
        text="You are about to be logged out. Please click OK to stay logged in."
        textYes="OK"
        onYesClick={this.props.onResetClick}
      />
    );
  }

  private renderTips(): JSX.Element {
    this.listenForChanges();

    // config.environment is never 'PROD', correct value is 'Production'
    // Not sure this if statement's functionality is desired regardless
    if (config.environment === 'PROD') {
      return <></>;
    }

    return (
      <>
        <div className="col-md-8">
          <div className="row">
            <div className="col-xs-12">
              {this.props.profile &&
                this.props.profile.firstName && (
                  <div className="row">
                    <h4 className="m-0 ml-10 pt-10 pl-5">
                      {this.props.profile.roles.length ? this.props.profile.roles.join(', ') : 'No Roles'} -{' '}
                      {this.props.profile.firstName + ' ' + this.props.profile.lastName}
                      {this.props.profile.mockedBy && (
                        <>
                          &nbsp;
                          <i className="fas fa-ban red-text pointer" onClick={this.props.stopMocking} />
                        </>
                      )}
                    </h4>
                  </div>
                )}
              <div className="row">
                <h1 className={['mt-10', classes.locationTitle].join(' ')}>{this.state.currentLocation}</h1>
              </div>
            </div>
          </div>
        </div>
        {config.environment !== 'Production' && <div className="col-md-2">Environment - {config.environment}</div>}
        {this.props.isLoggedIn && (
          <Link
            to={RouteDefinitions.help.Details}
            className="col-md-1 btn btn-primary"
            href={config.bucketUrl + '/FNHW-trainingManual.pdf'}
            target="_blank"
          >
            Help <i className="fa fa-fw fa-question" />
          </Link>
        )}
      </>
    );
  }

  private setCurrentLocation = (path: string): void => {
    const location = getModule(path);
    this.setState({ currentLocation: location });
  };
}



// WEBPACK FOOTER //
// ./src/header/_components/header.component.tsx